module.exports = CardReaderMonitor;

function CardReaderMonitor(){
		
	var _listeners = new Array(),
	
	//_readers['name'] = {state : , type : , card :  }
 	_readers = {},
 	//the possible reader states
 	_readerStates = Object.freeze({
		empty : 1,
		incorrectCardInserted : 2,
		cardIncorrectInserted : 3,
		correctCardInserted : 4
	});
	
	
	this.addListener = function(listener){
		_listeners.push(listener);
	}
	
	this.removeListener = function(listener){
		var index = _listeners.indexOf(listener);
		if(index > -1){
			_listeners.splice(index, 1);
		}
	}
	
	this.cardReaderCount = function(){
		return Object.getOwnPropertyNames(_readers).length;
	}
	
	this.insertedCardCount = function (){
		return _insertedCardCount;
	}
	
	
	
	this.incorrectCardInserted = function(readerName) {
		_readers[readerName].state = _readerStates.incorrectCardInserted;
		
		_listeners.forEach( function(listener, index, array) {
			if(listener != null && !(typeof listener.incorrectCardInserted === 'undefined') ){
				listener.incorrectCardInserted();
			}
		});
	}
	
	
	this.cardIncorrectInserted = function(readerName) {
		_readers[readerName].state = _readerStates.cardIncorrectInserted;
		
		_listeners.forEach( function( listener, index, array){
			if(listener != null && !(typeof listener.cardIncorrectInserted === 'undefined') ){
				listener.cardIncorrectInserted();
			}
		});
	}

	this.correctCardInserted = function(readerName, card) {
		
		_readers[readerName].state = _readerStates.correctCardInserted;
		_readers[readerName].card = card;
		
		var publicEidCard = card.getPublicApi();

		_listeners.forEach( function(listener, index, array){
			if(listener != null && !(typeof listener.correctCardInserted === 'undefined') ){
				listener.correctCardInserted(publicEidCard);
			}
		});
		
	}
	
	
	this.cardRemoved = function(readerName){
		if(typeof _readers[readerName] != "undefined" && _readers[readerName] != null)
		{
			var currentState = _readers[readerName].state;
			switch(currentState){
			case _readerStates.incorrectCardInserted : incorrectCardRemoved(readerName); break;
			case _readerStates.cardIncorrectInserted : incorrectInsertedCardRemoved(readerName); break;
			case _readerStates.correctCardInserted	 : 	correctCardRemoved(readerName); break;
			default: return; //reader was already empty...
			}
		}
		
		
	}

	function correctCardRemoved(readerName) {
		_readers[readerName].state = _readerStates.empty;
		
		
		_listeners.forEach( function(listener, index, array){
			if(listener != null && !(typeof listener.correctCardRemoved === 'undefined') ){
				listener.correctCardRemoved();
			}
		});
		
	}

	function incorrectInsertedCardRemoved(readerName) {
		_readers[readerDescription.name].state = _readerStates.empty;
		
		_listeners.forEach( function(listener, index, array){
			if(listener != null && !(typeof listener.incorrectInsertedCardRemoved === 'undefined') ){
				listener.incorrectInsertedCardRemoved();
			}
		});
		
	}

	function incorrectCardRemoved (readerName) {
		_readers[readerDescription.name].state = _readerStates.empty;
		
		_listeners.forEach( function(listener, index, array){
			if(listener != null && !(typeof listener.incorrectCardRemoved === 'undefined') ){
				listener.incorrectCardRemoved();
			}
		});
		
	}

	function noCardReaderFound(){
		
		_listeners.forEach( function(listener, index, array){
			if(listener != null && !(typeof listener.noCardReaderFound === 'undefined') ){
				listener.noCardReaderFound();
			}
		});
		
	}

	/**
	 * Add a card reader 
	 * @param readerDescription expected to have 2 properties:
	 * 	name (unique name of the card reader)
	 *  type (the type of the reader)
	 * 
	 */
	this.cardReaderConnected = function(readerDescription) {
		_readers[readerDescription.name] = {
				type : readerDescription.type,
				state : _readerStates.empty,
				card : null
		}

		_listeners.forEach( function (listener, index, array){
			if(listener != null && !(typeof listener.cardReaderConnected === 'undefined') ){
				listener.cardReaderConnected(readerDescription.name);
			}
		});
		
	}

	this.cardReaderDisconnected = function(readerName) {
		
		//fire a card removed also if a card was inserted
		if(_readers[readerName].state != _readerStates.empty ){
			this.cardRemoved(readerName);
		}
		
		_listeners.forEach(function (listener, index, array){
			if(listener != null && !(typeof listener.cardReaderDisconnected === 'undefined') ){
				listener.cardReaderDisconnected(readerName);
			}
		});
		
		delete _readers[readerName];
		
		//check if it was the only card reader connected
		if(Object.keys(_readers).length == 0){
			noCardReaderFound();
		}
		
	}

	/**
	* takes a list of reader discriptions to update the current state
	*/
	this.updateConnectedReaders = function(readerDiscriptionList){
		var internalReaderList = Object.getOwnPropertyNames(_readers);
		//check for new readers
		for(var i = 0; i< readerDiscriptionList.length ; i++){
			var readerName =readerDiscriptionList[i].name;
			if( typeof _readers[readerName] == "undefined" || ! _readers[readerName]){
				//it doesn't exist yet
				this.cardReaderConnected(readerDiscriptionList[i]);
			}else if(internalReaderList.indexOf(readerName) > 0){
				//reader is still connected
				internalReaderList.splice(internalReaderList.indexOf(readerName), 1);
			}
		}

		for(var i = 0 ; i < internalReaderList.length; i++){
			this.cardReaderDisconnected(internalReaderList[i]);
		}

		//check for removed ree
	}
	

	
	/**
	The api for public use
	*/
	var publicApi = {
		addEventListener : this.addListener,
		/**
		Remove a listener.
		@param listener		The listener to remove
		*/
		removeEventListener : this.removeListener,
		cardReaderCount : this.cardReaderCount,
		insertedCardCount : this.insertedCardCount
	};
	
	this.getPublicApi = function(){
		return publicApi;
	}
			
}


CardReaderMonitor.readerTypes = Object.freeze({
	pcscReader : 1,
	pinPad : 2 
});
